import ApiFactory from '../factories/ApiFactory';
import { serialize, prepAutocompleteData } from '@/services/UtilityService';

const list = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`crmweb/v1/users?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const autocomplete = (q, labelProp = ['name', 'surname'], valueProp = 'id') => {
	return new Promise((resolve) => {
		list(q).then((data) => {
			resolve(prepAutocompleteData(data, labelProp, valueProp));
		});
	});
};

const getPhonePrefixes = (id, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`/crmweb/v1/users/phone_prefixes`, payload).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'code', 'code'));
			},
			(error) => reject(error)
		);
	});
};

export default {
	list,
	autocomplete,
	getPhonePrefixes,
};
